export const Key = {
    access: "access",
    connectUser: "user.connect",
    loggedInUser: "user.commercial",
    log: "log",
    campaignData: "campaignData",
    returnUrl: "returnUrl",

    amountToPay: "business.balance",
    businessDetails: "business.details",
    contactDetails: "contact.details",
    agreements: "agreements",
    products: "products",
    errorCodes: "errorCodes",
    allBusinessDetails: "business.details.all",
    primaryService: "primaryService",
    latestStatements: "statement.latest",
    payment: "payment",

    freshDeskContact: "freshdesk.contact",
    madePayment: "business.payment.made",

    paymentSuccessQueryParam: "payment-success"
}

export const AllKeys = [
    Key.loggedInUser
    , Key.access
    , Key.campaignData
    , Key.contactDetails
    , Key.returnUrl
    , Key.amountToPay
    , Key.businessDetails
    , Key.contactDetails
    , Key.products
    , Key.errorCodes
    , Key.allBusinessDetails
    , Key.primaryService
    , Key.freshDeskContact
    , Key.madePayment
    , Key.latestStatements
]